import React from 'react';

export interface RoundedBlueContainerProps {
  children: React.ReactNode;
}

const RoundedBlueContainer = ({ children }: RoundedBlueContainerProps) => {
  return (
    <div
      className={
        'rounded-2xl bg-primary-navyblue-shade/[0.65] text-neutral-whiteboard px-6 max-md:py-6 md:py-8'
      }
    >
      {children}
    </div>
  );
};

export default RoundedBlueContainer;
